module.exports = __webpack_public_path__ + "img/6.df8bb067.jpg";